import { render } from "./EstadoBono.vue?vue&type=template&id=fb958cc4"
import script from "./EstadoBono.vue?vue&type=script&lang=js"
export * from "./EstadoBono.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__